import _isEmpty from 'lodash/isEmpty';

import { AUTH_FIELDS_NAMES } from '../constants/common';

export const EMAIL_REGEX = /^[-\w.%+]{1,64}@(?:[A-Z0-9-]{1,63}\.){1,125}[A-Z]{2,63}$/i;
export const ALPHA_REGEX = /^[-A-ZА-ЯЁ ]+$/i;
export const ONLY_MOBILE_DEF_CODES = [
  900,
  901,
  902,
  903,
  904,
  905,
  906,
  908,
  909,
  910,
  911,
  912,
  913,
  914,
  915,
  916,
  917,
  918,
  919,
  920,
  921,
  922,
  923,
  924,
  925,
  926,
  927,
  928,
  929,
  930,
  931,
  932,
  933,
  934,
  936,
  937,
  938,
  939,
  950,
  951,
  952,
  953,
  958,
  960,
  961,
  962,
  963,
  964,
  965,
  966,
  967,
  968,
  969,
  977,
  978,
  980,
  981,
  982,
  983,
  984,
  985,
  986,
  987,
  988,
  989,
  991,
  992,
  993,
  994,
  995,
  996,
  997,
  999,
];

export const validateText = (value) => {
  return typeof value !== 'undefined' && ALPHA_REGEX.test(value as string);
};

export const validatePhone = (value) => {
  if (!value) {
    return false;
  }
  value = value.replace(/[-_()\s]/g, '');
  const defCode = /^(8|\+7|7)\(?(\d{3})\)?[\d]{7,10}$/g.exec(value);
  return defCode !== null && ONLY_MOBILE_DEF_CODES.indexOf(parseInt(defCode[2], 10)) !== -1;
};

export const validateEmail = (value) => {
  return typeof value !== 'undefined' && EMAIL_REGEX.test(value as string);
};

export const validateField = (name: string, value: string): boolean => {
  if (_isEmpty(value)) return false;

  switch (name) {
    case AUTH_FIELDS_NAMES.NAME:
      return value.length > 1 && validateText(value);

    case AUTH_FIELDS_NAMES.CODE:
      return value.length > 2;

    case AUTH_FIELDS_NAMES.PHONE:
      return validatePhone(value);
  }
};

export const validateFields = (formValues) => {
  let isValid = true;

  Object.values(AUTH_FIELDS_NAMES).forEach((key) => {
    if (formValues[key] && !validateField(key, formValues[key].value)) {
      isValid = false;
    }
  });

  return isValid;
};
